import ListingPage from './listing-page';
export default ListingPage;